import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo1 from "../../assets/logo1.jpeg";
import "./footer.css";
import { IoLogoYoutube } from "react-icons/io";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPhoneAlt,
} from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaXTwitter } from "react-icons/fa6";
import UseMediaQuery from "./../Pages/UseMediaQuery";

const Footer = () => {
  const isMobile = UseMediaQuery("(max-width:486px)");
  const [activeId, setActiveId] = useState(null);

  const toggleCollapse = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const faqData = [
    {
      id: 1,
      question: "Quick Links",
      answer: [
        { name: "Home", link: "/" },
        { name: "Professionals", link: "/services" },

        { name: "About Us", link: "/about-us" },
        { name: "privacy policy", link: "/privacy-policy" },
        { name: "Terms And Conditions", link: "/terms-conditions" },
        { name: "Career", link: "/" },
      ],
    },
    {
      id: 2,
      question: "Contact Info",
      answer: [
        { name: "Contact Us", link: "/contact-us" },
        { name: "mestryCircle@.com", link: "/" },
        { name: "1-800-890-3030", link: "/" },
        { name: "79770 90909", link: "/" },
        { name: "Service", link: "/service" },
      ],
    },
    {
      id: 3,
      question: "Our Location",
      answer: [
        {
          name: (
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.1489969194486!2d77.61400677484!3d12.898139187410544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15792a4bc145%3A0x7fcd352d0ecfb49e!2sFicuslot%20Innovation%20Pvt%20Ltd.!5e0!3m2!1sen!2sin!4v1759753329426!5m2!1sen!2sin"
              className="contactLoc"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{
                width: "100%",
                height: "200px",
                border: "0",
                borderRadius: "10px",
              }}
              title="Mestry Circle Location"
            ></iframe>
          ),
          link: "",
        },
      ],
    },
  ];

  return (
    <div className="container-fluid footerBg ">
      <div className="col-12 hrFooter"></div>
      <div className="container  my-xxl-2 my-xl-2 my-lg-2 my-1">
        <div className="row">
          {/* Left Section */}
          <div className="col-md-3  col-lg-5 col-xl-3  my-xxl-3 my-xl-3 my-lg-3 my-1">
            <NavLink to="/">
              <img src={logo1} alt="Mestry Circle" className="headLogo" />
            </NavLink>
            <p className="footerp my-3">
              Providing Materials & Services. Building Trust. Shaping Tomorrow.
            </p>
            <div className="footerIcon">
              <ul
                className="d-flex flex-wrap gap-3 my-2 mobileDflex ulFooter"
                style={{ padding: "0px" }}
              >
                <li>
                  <Link to="https://www.facebook.com/login/">
                    <FaFacebookF className="footerIcon1" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.instagram.com/accounts/login">
                    <FaInstagram className="footerIcon2" />
                  </Link>
                </li>
                <li>
                  <Link to="https://x.com/i/flow/login">
                    <FaXTwitter className="footerIcon3" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.linkedin.com/login">
                    <FaLinkedinIn className="footerIcon4" />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/account">
                    <IoLogoYoutube className="footerIcon5" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {isMobile ? (
            <>
              <div className="col-md-6 my-1">
                {faqData.map((item) => (
                  <div
                    key={item.id}
                    className="border-bottom border-secondary py-2 py-lg-3"
                  >
                    <div
                      className="d-flex justify-content-between align-items-center px-2"
                      role="button"
                      onClick={() => toggleCollapse(item.id)}
                    >
                      <h5 className="footerQues">{item.question}</h5>
                      <h3 className="footerIcons">
                        {activeId === item.id ? (
                          <IoIosArrowUp size={15} />
                        ) : (
                          <IoIosArrowDown size={15} />
                        )}
                      </h3>
                    </div>

                    {activeId === item.id && (
                      <ul className="footerAnsList mt-2 px-3 d-flex flex-column gap-2">
                        {item.answer.map((ans, idx) => (
                          <li key={idx}>
                            {typeof ans.name === "string" ? (
                              <Link to={ans.link} className="footerLink">
                                {ans.name}
                              </Link>
                            ) : (
                              ans.name
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="col-md-2 my-xl-4 my-lg-4 my-md-3 my-1">
                <div className="logoApple">
                  <NavLink to="/" className="">
                    <img
                      src="https://hometriangle.com/images/svg/button-google-play.svg"
                      className="img-fluid appleLogo mb-3"
                      alt="Google Play"
                    />
                  </NavLink>
                  <NavLink to="/" className="">
                    <img
                      src="https://hometriangle.com/images/svg/button-appstore.svg"
                      className="img-fluid andriodLogo"
                      alt="App Store"
                    />
                  </NavLink>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-md-3 col-lg-3 col-xl-3  my-xl-4 my-lg-4 my-md-3 my-1">
                <ul className="footer1ul p-0 d-flex gap-2 flex-column">
                  <li>
                    <Link to="/">Quick Links</Link>
                  </li>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/services">Professionals</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-conditions">Terms And Conditions</Link>
                  </li>
                  <li>
                    <Link to="/">Career</Link>
                  </li>
                </ul>
              </div>

              <div className="col-md-3 col-lg-2 col-xl-3 my-xl-4 my-lg-4 my-md-3 my-1">
                <ul className="footer1ull p-0 d-flex gap-2 flex-column">
                  <li>
                    <Link to="">Contact Info</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/">
                      <span className="linkColor">mestryCircle@.com</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <span className="linkColor">
                        <FaPhoneAlt size={12} className="me-2" />
                        1-800-890-3030
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <span className="linkColor">
                        <FaPhoneAlt size={12} className="me-2" />
                        79770 90909
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/services">
                      <span className="linkColor2 mt-3">Services</span>
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-md-2 col-lg-2  col-xl-2 my-xl-4 my-lg-4 my-md-3 my-1">
                <div className="logoApple">
                  <NavLink to="/" className="">
                    <img
                      src="https://hometriangle.com/images/svg/button-google-play.svg"
                      className="img-fluid appleLogo mb-3"
                      alt="Google Play"
                    />
                  </NavLink>
                  <NavLink to="/" className="">
                    <img
                      src="https://hometriangle.com/images/svg/button-appstore.svg"
                      className="img-fluid andriodLogo"
                      alt="App Store"
                    />
                  </NavLink>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="row">
          <div className="col-12 horiRowFooter"></div>
          <div className="col-12 d-flex justify-content-center align-items-center">
            <p className="footerP my-xl-2 my-lg-2 my-md-1 my-1 text-center">
              © 2025, Mestry Circle. All Rights Reserved.
              <br />
              Designed and developed by Ficuslot Innovation Pvt Ltd
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
